import { createContext, useContext, useState } from "react";

// 1️⃣ Buat context
const AppContext = createContext();

// 2️⃣ Buat provider
export function AppProvider({ children }) {
  const [mainVM, setMainVM] = useState({
    // intialized state
  });

  return (
    <AppContext.Provider value={{ mainVM, setMainVM }}>
      {children}
    </AppContext.Provider>
  );
}

export function useAppContext() {
  return useContext(AppContext);
}
